export default __webpack_public_path__ + "static/ABCMaxiRoundMono-Regular-86cc09c4ba96249d78ae597defbc7696.woff";